"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("../Api"));
const Auth_1 = __importDefault(require("./Auth"));
const Category_1 = __importDefault(require("./Category"));
const Menu_1 = __importDefault(require("./Menu"));
const Merchant_1 = __importDefault(require("./Merchant"));
const Order_1 = __importDefault(require("./Order"));
const PromoCode_1 = __importDefault(require("./PromoCode"));
const Device_1 = __importDefault(require("./Device"));
const CRM_1 = __importDefault(require("./CRM"));
const Timeslot_1 = __importDefault(require("./Timeslot"));
class OrderappClientApi extends Api_1.default {
    constructor(baseUrlGo, baseUrlNode, configs = { locale: 'zh', appVersion: '' }) {
        super(baseUrlGo, baseUrlNode, configs);
        this.auth = new Auth_1.default(this);
        this.category = new Category_1.default(this);
        this.menu = new Menu_1.default(this);
        this.merchant = new Merchant_1.default(this);
        this.order = new Order_1.default(this);
        this.promoCode = new PromoCode_1.default(this);
        this.device = new Device_1.default(this);
        this.crm = new CRM_1.default(this);
        this.timeslot = new Timeslot_1.default(this);
    }
}
exports.default = OrderappClientApi;
//# sourceMappingURL=index.js.map